import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslocoModule } from '@jsverse/transloco';
import { UserNextTripsComponent } from '@shared/user-next-trips/components/user-next-trips.component';
import { NotificationDsComponent } from '@design-system/components/molecules/notification/notification.component';

@NgModule({
  declarations: [UserNextTripsComponent],
  imports: [
    TranslocoModule,
    CommonModule,
    NotificationDsComponent,
  ],
  exports: [UserNextTripsComponent],
  providers: [],
})
export class UserNextTripsModule { }
